/* Component Dependencies */
var reslinkAdaptiveHtmlHeadTemplate = require('templates/reslinkAdaptiveHtmlHead.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'reslinkAdaptiveHtmlHead',
  template: {
    'reslinkAdaptiveHtmlHead': reslinkAdaptiveHtmlHeadTemplate
  }
});